import React from "react";
import CesarLevano from "../images/contenido/PREMIACION LEVANO.jpg";
import Edmundo from "../images/contenido/PREMIACION EDMUNDO.jpg";
import Video from "../images/contenido/VideoLevano.jpg";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

const C4Otros = () => {
  return (
    <section id="otros" className="nosotros bg-brown-dark">
      <Fade delay={100} triggerOnce>
        <div className="block-circle"></div>
        <div className="container d-flex">
          <div className="images">
            <img src={Edmundo} alt="Edmundo Cruz" className="mohme-3" />
            <img src={CesarLevano} alt="Cesar Levano" className="mohme-1" />
            <img src={Video} alt="Video Cesar Levano" className="mohme-2" />
          </div>
          <div className="text">
            <h3 className="section-title">4. Otras iniciativas</h3>
            <div className="block-transparent"></div>
            <p>
              La fundación propugna que el legado de su preceptor perdure, se
              amplíe e ilumine a las siguientes generaciones de peruanas y
              peruanos dispuestos a esforzarse por lograr el desarrollo del
              país. Por ello, promueve distintas actividades para apoyar los
              esfuerzos de quienes buscan una sociedad más justa y reconoce el
              trabajo de aquellos que contribuyen en la defensa de la
              democracia.
            </p>
            <div>
              <div className="button-link">
                <Link to="/participacion-ciudadana-tribunal-constitucional">
                  4.1 Participación ciudadana en el proceso de selección de
                  magistrados del Tribunal Constitucional
                </Link>
              </div>
              <div className="button-link">
                <Link to="/premios-trayectoria">
                  4.2 Premio a la Trayectoria
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </section>
  );
};

export default C4Otros;
